export const validLanguages = ['en', 'es', 'fi', 'pt']
export const validSubtitleLanguages = ['en', 'sv', 'fi', 'es', 'pt']
